"use client";

import { useEffect } from "react";
import { Instagram, Youtube, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterNavConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        <li className="h-4 w-24 bg-muted animate-pulse rounded-md" />
        <li className="h-4 w-20 bg-muted animate-pulse rounded-md" />
        <li className="h-4 w-28 bg-muted animate-pulse rounded-md" />
        <li className="h-4 w-16 bg-muted animate-pulse rounded-md" />
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li data-index={i} key={item.id}>
          <Link to={item.href || "#"} className="text-foreground text-[15px] hover:text-primary transition-colors duration-200 font-default">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
const capabilities = [{
  label: "Credit Architecture",
  href: "/ServicesPage"
}, {
  label: "Business Credit Development",
  href: "/ServicesPage"
}, {
  label: "Personal Funding Solutions",
  href: "/FundingSolutionsPage"
}, {
  label: "Business Funding Solutions",
  href: "/FundingSolutionsPage"
}, {
  label: "Wealth Strategy",
  href: "/ServicesPage"
}, {
  label: "Financial Mentoring",
  href: "/ServicesPage"
}];
const socials = [{
  name: "Instagram",
  icon: Instagram,
  href: "#"
}, {
  name: "YouTube",
  icon: Youtube,
  href: "#"
}, {
  name: "X",
  icon: Twitter,
  href: "#"
}];
export default function Footer() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://widgets.leadconnectorhq.com/loader.js";
    script.setAttribute("data-resources-url", "https://widgets.leadconnectorhq.com/chat-widget/loader.js");
    script.setAttribute("data-widget-id", "6a28954df1441b3a2c8dd267");
    script.setAttribute("data-source", "WEB_USER");
    document.head.appendChild(script);
    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);
  return <section data-section-id="4966" id="footer" className="relative bg-background text-foreground pt-[120px] pb-12 px-6 md:px-10 lg:px-16">
      {}
      <span aria-hidden="true" className="absolute top-4 left-4 w-4 h-4 border-l border-t border-primary/40" />
      <span aria-hidden="true" className="absolute top-4 right-4 w-4 h-4 border-r border-t border-primary/40" />
      <span aria-hidden="true" className="absolute bottom-4 left-4 w-4 h-4 border-l border-b border-primary/40" />
      <span aria-hidden="true" className="absolute bottom-4 right-4 w-4 h-4 border-r border-b border-primary/40" />

      <div className="max-w-7xl mx-auto">
        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">
          {}
          <div className="lg:col-span-5 space-y-6">
            <Link to="/HomePage" className="inline-block">
              <WvcLogo className="h-8 w-auto" />
            </Link>
            <p className="text-[14px] text-muted-foreground font-default max-w-sm leading-relaxed">
              We don’t just repair credit. We architect financial solutions for the elite entrepreneur.
            </p>

            {}
            <div className="pt-4 space-y-1.5 font-mono text-[11px] text-primary uppercase tracking-widest">
              <div className="flex items-center gap-2">
                <span className="text-muted-foreground/70">EST</span>
                <span className="text-foreground/80">MMXXIV</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-muted-foreground/70">REF</span>
                <span className="text-foreground/80">BENE-FIN-001</span>
              </div>
            </div>

            {}
            <div className="flex items-center gap-5 pt-2">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <Link data-index={i} key={social.name} to={social.href} aria-label={social.name} className="group text-foreground hover:text-primary transition-colors duration-200">
                    <Icon className="w-5 h-5" strokeWidth={1} aria-hidden="true" />
                  </Link>;
            })}
            </div>
          </div>

          {}
          <div className="lg:col-span-2">
            <h3 className="font-mono text-[12px] uppercase tracking-[0.2em] text-primary mb-6 font-default">
              § 01 Navigate
            </h3>
            <MenuProvider menu_id="17">
              <FooterNavConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="lg:col-span-2">
            <h3 className="font-mono text-[12px] uppercase tracking-[0.2em] text-primary mb-6 font-default">
              § 02 Solutions
            </h3>
            <ul className="space-y-3">
              {capabilities.map((cap, i) => <li data-index={i} key={cap.label}>
                  <Link to={cap.href} className="text-foreground text-[15px] hover:text-primary transition-colors duration-200 font-default">
                    {cap.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="lg:col-span-3">
            <h3 className="font-mono text-[12px] uppercase tracking-[0.2em] text-primary mb-6 font-default">
              § 03 Headquarters
            </h3>
            <div className="space-y-4">
              <p className="text-[14px] text-muted-foreground leading-relaxed font-default">Flossmoor, Illinois 60422</p>
              <div className="space-y-2 font-mono text-[13px]">
                <Link to="mailto:concierge@benewealth.com" className="block text-foreground hover:text-primary transition-colors duration-200">help@benewealth.info</Link>
                <Link to="tel:+12125550199" className="block text-foreground hover:text-primary transition-colors duration-200">1-224-603-2619</Link>
              </div>
              <div className="pt-2 font-mono text-[11px] text-muted-foreground uppercase tracking-widest">
                <span className="text-muted-foreground/70">Consultation </span>
                <span className="text-foreground/80">By Appointment</span>
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="relative my-14">
          <div className="h-px bg-border w-full" />
          <span aria-hidden="true" className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center">
            <span className="block w-3 h-px bg-primary" />
            <span className="block w-px h-3 bg-primary absolute" />
          </span>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center font-mono text-[11px] uppercase tracking-[0.15em]">
          {}
          <div className="text-muted-foreground text-center md:text-left">© 2019 BENEWEALTH FINANCIAL · ARCHITECTS OF CAPITAL</div>

          {}
          <div className="flex justify-center">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 border border-border text-foreground/80 bg-secondary/10">
              <span className="text-primary/70">ID/</span>
              <span>BENE-CORP-NY</span>
            </span>
          </div>

          {}
          <div className="flex items-center gap-2 justify-center md:justify-end text-muted-foreground">
            <span className="w-1.5 h-1.5 rounded-md bg-primary animate-pulse" aria-hidden="true" style={{
            boxShadow: "0 0 8px var(--primary)"
          }} />
            <span>
              System Status: <span className="text-foreground/80">Secure</span> ·
              Uptime <span className="text-foreground/80">100%</span>
            </span>
          </div>
        </div>
      </div>
    </section>;
}